export enum UserRoles {
  Contractor = 'Contractor',
  AgencyManager = 'Agency manager',
  Recruiter = 'Recruiter',
  TrainingProvider = 'Training provider',
  Admin = 'Admin',
}

export enum PlatformTypes {
  Web = 'WEB',
  Mobile = 'MOB',
  Admin = 'ADMIN',
}

export enum ReCaptchaVersions {
  V2 = 'v2',
  V3 = 'v3',
}

export enum InviteStatuses {
  Accepted = 'Accepted',
  Pending = 'Pending',
  Expired = 'Expired',
  Seen = 'Seen',
  Rejected = 'Rejected',
}

export enum MemberStatuses {
  Active = 'Active',
  Inactive = 'Inactive',
}

export enum ContractStatuses {
  Draft = 'Draft',
  Live = 'Live',
  Ongoing = 'Ongoing',
  Complete = 'Completed',
  OnHold = 'On-hold',
  Incomplete = 'Unfulfilled',
  Cancelled = 'Cancelled',
}

export enum EmploymentType {
  SelfEmployed = 'self_employed',
  LimitedCompany = 'limited_company',
  UmbrellaPAYE = 'umbrella_paye',
  UmbrellaCIS = 'umbrella_cis',
}

export enum ApplicationStatuses {
  Pending = 'pending',
  Accepted = 'accepted',
  Declined = 'declined',
  Offered = 'offer',
  OfferAccepted = 'offer_accepted',
  OfferRejected = 'offer_rejected',
  Completed = 'completed',
  Cancelled = 'cancelled',
}

export enum ApplicationStatusesReadable {
  pending = 'Pending',
  accepted = 'Accepted',
  declined = 'Declined',
  offer = 'Offered',
  offer_accepted = 'Offer Accepted',
  offer_rejected = 'Offer Rejected',
  completed = 'Completed',
  cancelled = 'Cancelled',
}

export enum ContractorVerificationStatuses {
  Pending = 'pending',
  Verified = 'verified',
  NotVerified = 'not_verified',
  Blocked = 'blocked',
}
